import classNames from 'classnames'
import React from 'react'

import { User } from '@/model/user'

import s from './fan-name.module.css'

export interface FanNameProps {
  className?: string
  user: User
}

export default function FanName({
  className,
  user,
}: FanNameProps) {
  const { username, uid } = user
  return (
    <div className={classNames(s.FanName, className)}>
      <div className={s.Name}>
        <b title={username}>{username}</b>
      </div>
      {uid && <div className={s.Username}>@{uid}</div>}
    </div>
  )
}
